import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import PageMeta from "../../components/common/PageMeta";
import { useEffect, useState } from "react";
import Spinner from "../../components/ui/Spinner";
import {
    API_BASE_URL,
    API_URL,
    DEFAULT_PAGE_DESCRIPTION,
    DEFAULT_PAGE_TITLE,
} from "../../utilities/constants";
import { useParams } from "react-router";
import { useLocation } from 'react-router-dom';
import { handleApiCall } from "../../utilities/helper";

const UserDetails = () => {
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const [data, setData] = useState(null);
    const [controller, setController] = useState(null);
    const { id } = useParams();
    console.log("data", data)

    // useEffect(() => {
    //     if (data) {
    //         setLoading(false);
    //     }
    // }, [data]);


    const callListByIdApi = async () => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);
        try {
            const response = await handleApiCall(
                `${API_BASE_URL}/api/1.0.0/agent/${id}`,
                {
                    method: "GET"
                },
                null,
                signal
            );
            if (response.responseStatus == true) {
                setData(response.data);
            } else {
                setData(null);
            }
            if (response.responseCode !== 299) {
                setLoading(false);
            }
        } catch (e) {
            console.error("Error", e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        callListByIdApi();
    }, [id]);


    return (
        <>
            <PageMeta
                title={`User Details - ${DEFAULT_PAGE_TITLE}`}
                description={`User Details - ${DEFAULT_PAGE_DESCRIPTION}`}
            />

            <div className="flex justify-between items-center mb-4">
                <PageBreadcrumb
                    pageTitle="User Details"
                    breadcrumbs={[
                        { label: "User", path: "/user" },
                        { label: "User Details" }
                    ]}
                />
            </div>

            {loading ? (
                <div className="flex justify-center items-center">
                    <Spinner />
                </div>
            ) : (
                <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md mx-auto h-full">
                    <div className="flex flex-col md:flex-row gap-8">
                        <div className="w-full md:w-1/3 space-y-6">
                            <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-900 shadow-sm">
                                <h3 className="text-sm text-gray-500 dark:text-gray-400">Name</h3>
                                <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                                    {`${data?.firstName} ${data?.lastName}`}
                                </p>
                            </div>

                            <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-900 shadow-sm">
                                <h3 className="text-sm text-gray-500 dark:text-gray-400">EP ID</h3>
                                <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                                    {data?.agentEpId}
                                </p>
                            </div>

                            <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-900 shadow-sm">
                                <h3 className="text-sm text-gray-500 dark:text-gray-400">Email</h3>
                                <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                                    {data?.email}
                                </p>
                            </div>

                            <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-900 shadow-sm">
                                <h3 className="text-sm text-gray-500 dark:text-gray-400">Phone</h3>
                                <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                                    {data?.phoneNumber}
                                </p>
                            </div>

                            <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-900 shadow-sm flex items-center gap-5">
                                <h3 className="text-sm text-gray-500 dark:text-gray-400">Status</h3>
                                <span
                                    className={`px-3 py-1 text-sm rounded-full font-medium ${data?.status === 1
                                            ? "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-100"
                                            : "bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-100"
                                        }`}
                                >
                                    {data?.status === 1 ? "Active" : "Inactive"}
                                </span>
                            </div>

                            <div className="space-y-2">
                                <div className="flex items-center gap-2">
                                    <span className="text-sm text-gray-500 dark:text-gray-400">
                                        Eligible for Commission:
                                    </span>
                                    <span
                                        className={`px-2 py-1 text-xs rounded-full ${data?.isEligibleForCommission
                                                ? "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-100"
                                                : "bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-100"
                                            }`}
                                    >
                                        {data?.isEligibleForCommission ? "Yes" : "No"}
                                    </span>
                                </div>

                                <div className="flex items-center gap-2">
                                    <span className="text-sm text-gray-500 dark:text-gray-400">Manager:</span>
                                    <span
                                        className={`px-2 py-1 text-xs rounded-full ${data?.isManager
                                                ? "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-100"
                                                : "bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-100"
                                            }`}
                                    >
                                        {data?.isManager ? "Yes" : "No"}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="flex-1 md:pl-8 md:border-l border-gray-200 dark:border-gray-700 space-y-8">
                            <div>
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">
                                    Departments & SubDepartments
                                </h2>

                                {data?.agentDepartments?.length > 0 ? (
                                    data.agentDepartments.map((dept) => (
                                        <div
                                            key={dept.agentDepartmentId}
                                            className="mb-6 p-4 bg-gray-50 dark:bg-gray-900 rounded-lg shadow-sm"
                                        >
                                            <p className="text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
                                                {dept.subDepartment?.department?.departmentName} →{" "}
                                                {dept.subDepartment?.subDepartmentName}
                                            </p>

                                            {dept.subDepartment?.subDepartmentModules?.length > 0 && (
                                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2">
                                                    {dept.subDepartment.subDepartmentModules.map((mod) => (
                                                        <div
                                                            key={mod.subDepartmentModuleId}
                                                            className="p-3 rounded-lg bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 flex justify-between items-center"
                                                        >
                                                            <span className="text-sm text-gray-800 dark:text-gray-100">
                                                                {mod.module?.moduleName}
                                                            </span>
                                                           
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    ))
                                ) : (
                                    <p className="text-sm text-gray-500 dark:text-gray-400">No departments assigned.</p>
                                )}
                            </div>
                            <div>
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">
                                    Module Access
                                </h2>

                                {data?.agentModulesAccess?.length > 0 ? (
                                    <div className="space-y-3">
                                        {data.agentModulesAccess.map((m) => (
                                            <div
                                                key={m.agentModuleId}
                                                className="p-4 rounded-lg bg-gray-50 dark:bg-gray-900 shadow-sm"
                                            >
                                                <div className="flex items-center justify-between mb-2">
                                                    <span className="text-sm font-medium text-gray-800 dark:text-gray-100">
                                                        {m.module?.moduleName}
                                                    </span>
                                                </div>

                                                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <div className="flex items-center gap-2">
          <span className="text-xs font-medium text-gray-600 dark:text-gray-300">Add:</span>
          <span
            className={`px-2 py-1 text-xs rounded-full ${
              m.addAccess
                ? "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-100"
                : "bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-100"
            }`}
          >
            {m.addAccess ? "Yes" : "No"}
          </span>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-xs font-medium text-gray-600 dark:text-gray-300">Edit:</span>
          <span
            className={`px-2 py-1 text-xs rounded-full ${
              m.editAccess
                ? "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-100"
                : "bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-100"
            }`}
          >
            {m.editAccess ? "Yes" : "No"}
          </span>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-xs font-medium text-gray-600 dark:text-gray-300">View:</span>
          <span
            className={`px-2 py-1 text-xs rounded-full ${
              m.viewAccess
                ? "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-100"
                : "bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-100"
            }`}
          >
            {m.viewAccess ? "Yes" : "No"}
          </span>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-xs font-medium text-gray-600 dark:text-gray-300">Delete:</span>
          <span
            className={`px-2 py-1 text-xs rounded-full ${
              m.deleteAccess
                ? "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-100"
                : "bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-100"
            }`}
          >
            {m.deleteAccess ? "Yes" : "No"}
          </span>
        </div>
      </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <p className="text-sm text-gray-500 dark:text-gray-400">No module access.</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );


}
export default UserDetails;